import React from 'react';
import {
    IonItem,
    IonLabel,
    IonCheckbox,
    IonRange,
    IonSelect,
    IonSelectOption,
} from '@ionic/react';
import {_getDepartmentsList, _getIndianStates, _getWorkTypes} from '../apiHelpers/CommonHelper';
import {actionToGetJobPostingByFilter} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";

export default function FilterSidebar({myJobPostsData,selectedJobListUserType}) {
    const {
        selectedWorkTypes, setSelectedWorkTypes, selectedDepartments, setSelectedDepartments,
        selectedState, setSelectedState,experience, setExperience,salaryRange, setSalaryRange,
        resetFilters
    }= useStore();

    const handleWorkTypeCheckboxChange = (value) => {
        let newWorkTypes;
        if (selectedWorkTypes.includes(value)) {
            newWorkTypes = selectedWorkTypes.filter((v) => v !== value);
        } else {
            newWorkTypes = [...selectedWorkTypes, value];
        }

        setSelectedWorkTypes(newWorkTypes);
        handleApplyFilters(newWorkTypes, selectedDepartments, selectedState, experience, salaryRange);
    };

    const handledDepartmentCheckboxChange = (value) => {
        let newDepartments;
        if (selectedDepartments.includes(value)) {
            newDepartments = selectedDepartments.filter((v) => v !== value);
        } else {
            newDepartments = [...selectedDepartments, value];
        }

        setSelectedDepartments(newDepartments);
        handleApplyFilters(selectedWorkTypes, newDepartments, selectedState, experience, salaryRange);
    };

    const handleApplyFilters = async (workType,department,location,experience,salary) => {
        const payload = {};
        if (workType.length > 0) payload.work_type = workType;
        if (department.length > 0) payload.department = department;
        if (location.length > 0) payload.location = location;
        if (experience > 0) payload.experience = experience;
        if (salary > 0) payload.salary = salary;
        payload.me_mode = !!myJobPostsData;
        payload.user_type = selectedJobListUserType;
        await actionToGetJobPostingByFilter(true,payload);
    };

    const handleClearFilters = async () => {
        resetFilters();
        await actionToGetJobPostingByFilter(true,{me_mode:!!myJobPostsData,user_type:selectedJobListUserType});
    };

    const showApplyButton =
        selectedWorkTypes.length > 0 ||
        selectedDepartments.length > 0 ||
        selectedState.length > 0 ||
        experience > 0 ||
        salaryRange > 0;

    const handleExperienceChange = (e) => {
        setExperience(Number(e.detail.value));
        handleApplyFilters(selectedWorkTypes,selectedDepartments,selectedState,Number(e.detail.value),salaryRange);
    };

    const handleStateChange = (e) => {
        setSelectedState(e.detail.value);
        handleApplyFilters(selectedWorkTypes,selectedDepartments,e.detail.value,experience,salaryRange);
    };

    const handleSalaryChange = (e) => {
        setSalaryRange(Number(e.detail.value));
        handleApplyFilters(selectedWorkTypes,selectedDepartments,selectedState,experience,Number(e.detail.value));
    };

    return (
        <div className="filter-sidebar-content">
            <div className={"filter_main_heading_container"}>
                <h3 className="filter_main_heading">All Filters</h3>
                {(showApplyButton) && (
                    <div className="filter-section-button-he clear" onClick={handleClearFilters}>Clear</div>
                )}
            </div>

            {/* Work mode */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Work mode</h4>
                {_getWorkTypes.map((type) => (
                    <IonItem lines="none" key={type}>
                        <IonCheckbox
                            slot="start"
                            checked={selectedWorkTypes.includes(type)}
                            onIonChange={() =>
                                handleWorkTypeCheckboxChange(type)
                            }
                        />
                        <IonLabel>{type}</IonLabel>
                    </IonItem>
                ))}
            </div>
            <hr/>

            {/* Experience */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Experience</h4>
                <IonRange
                    min={0}
                    max={20}
                    pin
                    snaps
                    step={1}
                    value={experience}
                    onIonChange={handleExperienceChange}
                />
                <div className="range-labels">
                    <span>{experience} Yrs</span>
                    <span>{experience === 0 ? 'Any' : ''}</span>
                </div>
            </div>
            <hr/>
            {/* Location */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Location</h4>
                <IonItem lines="none">
                    <IonSelect
                        multiple={true}
                        placeholder="Select Location"
                        value={selectedState}
                        onIonChange={handleStateChange}
                    >
                        {_getIndianStates.map((state, index) => (
                            <IonSelectOption key={index} value={state}>
                                {state}
                            </IonSelectOption>
                        ))}
                    </IonSelect>
                </IonItem>
            </div>

            <hr/>
            {/* Salary */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Salary</h4>
                <IonRange
                    min={0}
                    max={30}
                    step={1}
                    pin
                    value={salaryRange}
                    onIonChange={handleSalaryChange}
                />
                <div className="range-labels" style={{display: 'flex', justifyContent: 'space-between'}}>
                    <span>{salaryRange.lower} LPA</span>
                    <span>30+ LPA</span>
                </div>
            </div>
            <hr/>
            {/* Department */}
            <div className="filter-section">
                <h4 className="filter_main_heading_2">Department</h4>
                {_getDepartmentsList.map((dept) => (
                    <IonItem lines="none" key={dept}>
                        <IonCheckbox
                            slot="start"
                            checked={selectedDepartments.includes(dept)}
                            onIonChange={() =>
                                handledDepartmentCheckboxChange(dept, selectedDepartments, setSelectedDepartments)
                            }
                        />
                        <IonLabel>{dept}</IonLabel>
                    </IonItem>
                ))}
            </div>
        </div>
    );
}
